import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  TelegramIcon,
  WhatsappIcon,
  XIcon,
  LineShareButton,
  EmailShareButton,
  EmailIcon,
  LineIcon,
} from "react-share";

export type SocialNetwork =
  | "Facebook"
  | "Twitter"
  | "Linkedin"
  | "Telegram"
  | "Whatsapp"
  | "Line"
  | "Email"
  | "X";

const social = {
  Facebook: FacebookShareButton,
  Twitter: TwitterShareButton,
  Linkedin: LinkedinShareButton,
  Telegram: TelegramShareButton,
  Whatsapp: WhatsappShareButton,
  Line: LineShareButton,
  Email: EmailShareButton,
  X: TwitterShareButton,
} satisfies Record<SocialNetwork, React.ComponentType<any>>;

const socialIcons = {
  Facebook: FacebookIcon,
  Twitter: XIcon,
  Linkedin: LinkedinIcon,
  Telegram: TelegramIcon,
  Whatsapp: WhatsappIcon,
  Line: LineIcon,
  Email: EmailIcon,
};

export default function ShareButtons({
  url,
  iconSize = 32,
  iconColor,
  networks = [
    "Facebook",
    "Twitter",
    "Linkedin",
    "Telegram",
    "Whatsapp",
    "Line",
    "Email",
  ],
  onClick,
}: {
  readonly url: string;
  readonly iconSize?: number;
  readonly iconColor?: string;
  readonly networks?: SocialNetwork[];
  readonly onClick?: (network: string, url: string) => void;
}) {
  return (
    <div style={{ display: "inline-flex", gap: 10 }}>
      {Object.entries(social)
        .filter(([key]) => networks.includes(key as SocialNetwork))
        .map(([key, Component]) => {
          const Icon = socialIcons[key];
          return (
            <Component
              data-testid={`share-button-${key}`}
              key={key}
              url={url}
              onClick={(_e, link) => onClick?.(key as SocialNetwork, link)}
            >
              <Icon size={iconSize} round bgStyle={{ fill: iconColor }} />
            </Component>
          );
        })}
    </div>
  );
}
